const discrepancyStandardization = {
  dashboard: "Dashboard",
  configuration: "Configuration",
  discrepancy: "Discrepancy",
  discrepancy_configuration: "Discrepancy Configuration",
  invoice_delivery_note: "Invoice <> Delivery Note",
  invoice_delivery_note_description:
    "Compare PO based invoice lines with the delivery note lines they are linked to",
  invoice_purchase_order: "Invoice <> Purchase Order",
  invoice_purchase_order_description:
    "Compare PO based invoice lines with the purchase order lines they are linked to",
  match_unit_price: "Match unit price",
  match_unit_price_description_delivery_note:
    "Flag when invoice price differs from the delivery note price",
  match_unit_price_description_purchase_order:
    "Flag when invoice price differs from the purchase order price",
  unit_price_tolerance: "Unit price tolerance",
  unit_price_tolerance_description:
    "Absolute amount, e.g. 0.50 allows a difference up to 0.50",
  match_quantity: "Match quantity",
  match_quantity_description_delivery_note:
    "Flag when invoiced quantity exceeds what is left on the delivery note (after other invoices)",
  match_quantity_description_purchase_order:
    "Flag when invoiced quantity exceeds what is left on the purchase order (after other invoices)",
  quantity_tolerance: "Quantity tolerance",
  quantity_tolerance_description: "Absolute number of units allowed over",
  detect_missing_delivery_note_reference:
    "Detect missing delivery note reference",
  detect_missing_delivery_note_reference_description:
    "Flag invoice lines that could not be linked to a delivery note line",
  detect_missing_purchase_order_reference:
    "Detect missing purchase order reference",
  detect_missing_purchase_order_reference_description:
    "Flag invoice lines that could not be linked to a PO line",
  detect_description_mismatch: "Detect description mismatch",
  detect_description_mismatch_description:
    "Flag when the invoice line description differs from the delivery note line description (case and extra spaces are ignored)",
  invoice_goods_received_note: "Invoice <> Goods Received Note",
  invoice_goods_received_note_description:
    "Compare PO based invoice lines with the goods received note lines they are linked to",
  match_unit_price_description_goods_received_note:
    "Flag when invoice price differs from the goods received note price",
  match_quantity_description_goods_received_note:
    "Flag when invoiced quantity exceeds what is left on the goods received note (after other invoices)",
  detect_missing_goods_received_note_reference:
    "Detect missing goods received note reference",
  detect_missing_goods_received_note_reference_description:
    "Flag invoice lines that could not be linked to a goods received note line",
  detect_description_mismatch_description_goods_received_note:
    "Flag when the invoice line description differs from the goods received note line description (case and extra spaces are ignored)",
  notifications: "Notifications",
  discrepancy_emails: "Discrepancy emails",
  discrepancy_emails_description: "Sent when a discrepancy is detected",
  email_supplier_on_discrepancy: "Email supplier on discrepancy",
  email_user_on_discrepancy: "Email user on discrepancy",
  daily_reminder_email: "Daily reminder email",
  daily_reminder_email_description: "Daily summary of open discrepancies",
  reset: "Reset",
  save: "Save",
  saved_successfully: "Discrepancy configuration saved successfully",
  something_went_wrong: "Something went wrong",
  field_required: "This field is required",
  value_cannot_be_negative: "Value cannot be less than 0",
  value_cannot_exceed_max: "Value cannot be greater than 5",
  "You have unsaved changes. Are you sure you want to leave?":
    "You have unsaved changes. Are you sure you want to leave?",
};

export default discrepancyStandardization;
